/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDobbiesStoreBasedNotifications contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum searchRadiusUnit {
    miles = 'miles',
    kilometers = 'kilometers'
}

export interface IDobbiesStoreBasedNotificationsConfig extends Msdyn365.IModuleConfig {
    shouldShowYouMightAlsoLike?: boolean;
    discountAppliedInCartMessage?: string;
    productBundlesOrderSummaryText?: string;
    storeBasedNotifications?: IStoreBasedNotificationsData[];
    lookupRadius: number;
    searchRadiusUnit?: searchRadiusUnit;
    latitude?: number;
    longitude?: number;
}

export interface IDobbiesStoreBasedNotificationsResources {
    resourceKey: string;
}

export const enum StoreBasedNotificationsNotificationType {
    event = 'event',
    products = 'products'
}

export interface IStoreBasedNotificationsData {
    storeName: string;
    notificationBannerImage: string;
    notificationBannerHeading?: string;
    notificationBannerSubHeading?: string;
    notificationHeading: string;
    notificationType?: StoreBasedNotificationsNotificationType;
    activePoints?: IActivePointsData[];
    notificationContent: Msdyn365.RichText;
    notificationFooter: Msdyn365.RichText;
    notificationStartDate?: string;
    notificationShowEndDate?: string;
}

export interface IActivePointsData {
    xPosition?: number;
    yPosition?: number;
    radius?: number;
    itemId?: string;
}

export interface IDobbiesStoreBasedNotificationsProps<T> extends Msdyn365.IModule<T> {
    resources: IDobbiesStoreBasedNotificationsResources;
    config: IDobbiesStoreBasedNotificationsConfig;
    slots: {
        notificationProductsSlot: React.ReactNode[];
    };
}
